
  document.addEventListener('DOMContentLoaded', function() {
    const closeBtn = document.querySelector('.js-sb-cart-footer__hint-toggle');
    const hintBlock = document.querySelector('.js-sb-cart-footer__hint-text');
     if (closeBtn && hintBlock) {
      closeBtn.addEventListener('click', function() {
        hintBlock.style.display = 'none';
      });
    }
  });

